type Pixel = ((...args: unknown[]) => void) & { queue: unknown[][]; callMethod?: (...args: unknown[]) => void; push?: Pixel; loaded?: boolean; version?: string };
const CONSENT_KEY = "envelaro:advertising-consent:v1";
const rawId = import.meta.env.VITE_META_PIXEL_ID ?? "";
export const metaPixelConfigured = /^\d{5,25}$/.test(rawId);
let initialized = false;
let lastPage = "";
const sentLeads = new Set<string>();
function pixelWindow() { return window as Window & { fbq?: Pixel; _fbq?: Pixel }; }
export function advertisingAllowed() {
  if (typeof window === "undefined" || !metaPixelConfigured) return false;
  try { return window.localStorage.getItem(CONSENT_KEY) === "accepted"; } catch { return false; }
}
export function advertisingChoice() {
  if (typeof window === "undefined") return null;
  try { return window.localStorage.getItem(CONSENT_KEY); } catch { return null; }
}
export function setAdvertisingChoice(allowed: boolean) {
  try { window.localStorage.setItem(CONSENT_KEY, allowed ? "accepted" : "rejected"); } catch { return; }
  if (!allowed) {
    pixelWindow().fbq?.("consent", "revoke");
    lastPage = "";
    for (const name of ["_fbp", "_fbc"]) {
      document.cookie = name + "=; Max-Age=0; Path=/";
      document.cookie = name + "=; Max-Age=0; Path=/; Domain=.envelaro.com";
    }
  }
}
function ensurePixel() {
  if (!advertisingAllowed()) return null;
  const target = pixelWindow();
  if (!target.fbq) {
    const queue: unknown[][] = [];
    const fbq = ((...args: unknown[]) => { if (fbq.callMethod) fbq.callMethod(...args); else queue.push(args); }) as Pixel;
    fbq.queue = queue; fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0";
    target.fbq = fbq; target._fbq = fbq;
  }
  if (!initialized) {
    initialized = true;
    target.fbq("set", "autoConfig", false, rawId);
    target.fbq("init", rawId);
    const script = document.createElement("script");
    script.async = true; script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.append(script);
  }
  target.fbq("consent", "grant");
  return target.fbq;
}
export function trackPublicPage(pathname: string) {
  const pixel = ensurePixel();
  if (!pixel || lastPage === pathname) return;
  lastPage = pathname;
  pixel("track", "PageView");
}
export function trackSavedLead(eventId: string) {
  const pixel = ensurePixel();
  if (!pixel || sentLeads.has(eventId)) return;
  sentLeads.add(eventId);
  pixel("track", "Lead", {}, { eventID: eventId });
}
